import { lazy, Suspense } from "react";
import { Working } from "@/ui/Working";

/** The call page pulls in livekit-client, so it loads only when a call starts. */
const VoiceCallPage = lazy(() => import("./VoiceCallPage").then((m) => ({ default: m.VoiceCallPage })));

export function LazyVoiceCallPage() {
  return (
    <Suspense fallback={<Working message="Connecting." />}>
      <VoiceCallPage />
    </Suspense>
  );
}
